module.exports = __webpack_public_path__ + "img/login_bg_011.cafc44bf.jpg";